<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：门店-店员列表-添加店员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="addRules" label-width="200px">
      <!--添加店员-->
      <div class="common-form">添加商户</div>
      <el-form-item label="商户名称" prop="supplier.name">
        <el-input class="max-w460" v-model="form.supplier.name" placeholder="请输入商户名称"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="supplier.user_name">
        <el-input class="max-w460" v-model="form.supplier.user_name" placeholder="请输入账号"></el-input>
       </el-form-item>
      <el-form-item label="登录密码" prop="supplier.password">
        <el-input v-model="form.supplier.password" placeholder="请输入登录密码" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="supplier.confirm_password">
        <el-input v-model="form.supplier.confirm_password" placeholder="请输入确认密码" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="supplier.link_name">
        <el-input class="max-w460" v-model="form.supplier.link_name" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="supplier.link_phone">
        <el-input class="max-w460" v-model="form.supplier.link_phone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="门店logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('logo')">选择图片</el-button>
          <div v-if="form.supplier.logo_id!=''" class="img">
            <img :src="logo_file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="主营业务" prop="supplier.category_ids">
        <el-select v-model="form.supplier.category_ids" placeholder="请选择" multiple style="width: 460px;">
          <el-option v-for="(item, index) in category" :key="index" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺类型">
        <el-radio-group v-model="form.supplier.store_type">
          <el-radio :label="10">普通</el-radio>
          <el-radio :label="20">自营</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="省/市/区">
        <el-cascader
          v-model="form.supplier.region_path"
          :placeholder="regionPlaceholder"
          :options="regionOptions"
          :props="{ value: 'id', label: 'name', children: 'children' }"
          :show-all-levels="true"
          clearable
          style="width: 460px;"
        />
      </el-form-item>
      <el-form-item label="门店地址">
        <el-input class="max-w460" v-model="form.supplier.address" placeholder="请输入门店地址或通过地图选点填充"></el-input>
      </el-form-item>
      <el-form-item label="门店位置">
        <Getpoint @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
        <p v-if="form.supplier.longitude && form.supplier.latitude" class="coord-hint">
          已选坐标：{{ form.supplier.longitude }}, {{ form.supplier.latitude }}
        </p>
        <p v-else class="coord-hint coord-hint-warn">未选择门店坐标，将影响距离排序与导航</p>
      </el-form-item>
      <el-form-item label="营业执照">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('business')">选择图片</el-button>
          <div v-if="form.supplier.business_id!=''" class="img">
            <img :src="business_file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="绑定用户">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="userClick()">选择用户</el-button>
          <div v-if="form.supplier.user_id!=0" class="img">
            <span>{{user_info.nickName}}</span>
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="绑定权益">
        <el-select v-model="form.supplier.member_benefit_id" placeholder="请选择会员权益" clearable style="width: 460px;" @change="onBenefitIdChange">
          <el-option label="不绑定" :value="0"></el-option>
          <el-option v-for="item in benefitList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="权益周期">
        <el-date-picker
          v-model="benefitDateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :disabled="!form.supplier.member_benefit_id"
          clearable
          style="width: 460px;"
        />
        <p class="form-tip">需先绑定权益；不选表示不限制生效日期</p>
      </el-form-item>
      <el-form-item label="商家介绍" prop="supplier.description">
        <el-input type="textarea" v-model="form.supplier.description" class="max-w460"></el-input>
      </el-form-item>
      <el-divider content-position="left">扩展信息</el-divider>
      <el-form-item label="所属行业">
        <el-select v-model="form.supplier.industry_code" placeholder="请选择" clearable style="width: 460px;">
          <el-option v-for="item in industryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作意向">
        <el-select v-model="form.supplier.cooperative_purpose_type" placeholder="请选择" style="width: 460px;">
          <el-option v-for="item in cooperativePurposeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="加盟身份">
        <el-select v-model="form.supplier.franchisee_type" placeholder="请选择" style="width: 460px;">
          <el-option v-for="item in franchiseeTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="邀请码">
        <el-input v-model="form.supplier.inviter_code" placeholder="邀请码" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.supplier.sort" :min="0" :max="999999" controls-position="right" class="max-w460" />
        <p class="form-tip">数字越大越靠前，默认为 0</p>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--管理用户-->
    <GetUser :is_open="open_user" @close="closeDialogFunc($event, 'add')"></GetUser>
  </div>
</template>

<script>
  import SupplierApi from '@/api/supplier.js';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUser.vue';
  import Getpoint from '@/components/map/Getpoint.vue';
  import request from '@/utils/request';
  import {
    fetchSupplierEnumOptions,
    FALLBACK_COOPERATIVE_PURPOSE_OPTIONS,
    FALLBACK_FRANCHISEE_TYPE_OPTIONS,
    FALLBACK_INDUSTRY_OPTIONS,
  } from '@/utils/supplierEnumOptions';
  export default {
    components: {
      Upload,
      GetUser,
      Getpoint
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          supplier:{
            name: '',
            user_name: '',
            password: '',
            confirm_password: '',
            link_name: '',
            link_phone: '',
            address: '',
            description: '',
            logo_id: 0,
            business_id: 0,
            open_service: 0,
            category_ids: [],
            user_id: 0,
            store_type:10,
            member_benefit_id: 0,
            member_benefit_start_date: '',
            member_benefit_end_date: '',
            industry_code: '',
            region_path: [],
            province_id: 0,
            city_id: 0,
            region_id: 0,
            longitude: '',
            latitude: '',
            cooperative_purpose_type: 2,
            franchisee_type: 0,
            inviter_code: '',
            sort: 0
          },
        },
        addRules: {
          'supplier.name': [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
          'supplier.user_name': [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          'supplier.password': [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
          'supplier.confirm_password': [{ required: true, message: '请确认登录密码', trigger: 'blur' }],
          'supplier.link_name': [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          'supplier.link_phone': [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          'supplier.category_ids': [{ type: 'array', required: true, min: 1, message: '请选择主营业务', trigger: 'change' }],
        },
        industryOptions: [...FALLBACK_INDUSTRY_OPTIONS],
        cooperativePurposeOptions: [...FALLBACK_COOPERATIVE_PURPOSE_OPTIONS],
        franchiseeTypeOptions: [...FALLBACK_FRANCHISEE_TYPE_OPTIONS],
        benefitList: [],
        benefitDateRange: null,
        regionOptions: [],
        regionPlaceholder: '请选择省/市/区',
        logo_file_path: '',
        business_file_path: '',
        /*是否打开添加弹窗*/
        open_add: false,
        storeList: [],
        category: [],
        /*是否上传图片*/
        isupload: false,
        loading: false,
        type:'logo',
        open_user: false,
        user_info: {}
      };
    },
    created() {
      this.getCategoryList();
      this.getBenefitList();
      this.loadRegionTree();
      fetchSupplierEnumOptions().then(opt => {
        this.industryOptions = opt.industryOptions
        this.cooperativePurposeOptions = opt.cooperativePurposeOptions
        this.franchiseeTypeOptions = opt.franchiseeTypeOptions
      }).catch(() => {});
    },
    methods: {
      onBenefitIdChange(v) {
        if (!v) this.benefitDateRange = null;
      },
      getBenefitList() {
        const self = this;
        SupplierApi.getBenefitList({}, true).then(res => {
          if (res.data && res.data.list) self.benefitList = res.data.list;
        }).catch(() => {});
      },
      loadRegionTree() {
        return request._get('/shop/region.region/tree').then(res => {
          this.regionOptions = res.data.list || [];
          return this.regionOptions;
        }).catch(() => {});
      },
      getRegionTextByPath(path) {
        if (!Array.isArray(path) || !path.length || !this.regionOptions || !this.regionOptions.length) return '';
        let curOptions = this.regionOptions;
        const labels = [];
        for (const id of path) {
          const node = (curOptions || []).find(item => String(item.id) === String(id));
          if (!node) break;
          labels.push(node.name);
          curOptions = node.children || [];
        }
        return labels.length ? labels.join(' / ') : '';
      },
      getMapdataFunc() {},
      choseFunc(e) {
        if (!e || !e.location) return;
        this.form.supplier.latitude = e.location.lat;
        this.form.supplier.longitude = e.location.lng;
        // 地图点击（逆地理）与搜索结果字段结构不同
        const addr = e.address
          || e.title
          || (e.formatted_addresses && e.formatted_addresses.recommend)
          || '';
        if (addr) {
          this.form.supplier.address = addr;
        }
      },
      /*获取广告类别*/
      getCategoryList() {
        let self = this;
        let Params = {};

        SupplierApi.toaddSupplier(Params, true)
          .then(res => {
            self.category = res.data.category;
            if(self.category.length > 0){
              self.form.category_id = self.category[0].category_id;
            }
          })
          .catch(error => {

          });
      },
      onSubmit() {
        let self = this;
        let form = self.form;
        const path = (form.supplier.region_path || []);
        form.supplier.province_id = path[0] || 0;
        form.supplier.city_id = path[1] || 0;
        form.supplier.region_id = path[2] || 0;
        self.$refs.form.validate((valid, invalidFields) => {
          if (!valid) {
            let tip = '请完善必填项后再提交';
            if (invalidFields) {
              const first = Object.keys(invalidFields).reduce((msg, key) => {
                if (msg) return msg;
                const errs = invalidFields[key];
                return (errs && errs[0] && errs[0].message) || '';
              }, '');
              if (first) tip = first;
            }
            self.$message.warning(tip);
            return;
          }
          if (form.supplier.password !== form.supplier.confirm_password) {
            self.$message.warning('两次输入的密码不一致');
            return;
          }
          self.loading = true;
            const submitData = JSON.parse(JSON.stringify(form));
            delete submitData.supplier.region_path;
            const bid = submitData.supplier.member_benefit_id;
            if (bid && self.benefitDateRange && self.benefitDateRange.length === 2) {
              submitData.supplier.member_benefit_start_date = self.benefitDateRange[0] || null;
              submitData.supplier.member_benefit_end_date = self.benefitDateRange[1] || null;
            } else {
              submitData.supplier.member_benefit_start_date = null;
              submitData.supplier.member_benefit_end_date = null;
            }
            SupplierApi.addSupplier(submitData, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，商户添加成功',
                    type: 'success'
                  });
                  self.$router.push('/supplier/supplier/index');
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
        });
      },

     /*上传*/
     openUpload(e) {
       this.type = e;
       this.isupload = true;
     },

     /*获取图片*/
     returnImgsFunc(e) {
       if (e != null && e.length > 0) {
         if(this.type == 'logo'){
           this.logo_file_path = e[0].file_path;
           this.form.supplier.logo_id = e[0].file_id;
         }else if(this.type == 'business'){
           this.business_file_path = e[0].file_path;
           this.form.supplier.business_id = e[0].file_id;
         }
       }
       this.isupload = false;
     },


      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*打开弹出层*/
      userClick() {
        this.open_user = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.supplier.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
  .form-tip {
    margin: 6px 0 0;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }
  .coord-hint {
    margin: 8px 0 0;
    font-size: 12px;
    color: #606266;
    line-height: 1.4;
  }
  .coord-hint-warn {
    color: #e6a23c;
  }
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/add.vue